import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M3 5.25h4.25V4c0-.744.364-1.425.845-1.905.48-.48 1.161-.845 1.905-.845h4c.744 0 1.425.364 1.905.845.48.48.845 1.161.845 1.905v1.25H21a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1 0-1.5m6.155-2.095c-.27.27-.405.589-.405.845v1.25h6.5V4c0-.256-.136-.575-.405-.845-.27-.27-.589-.405-.845-.405h-4c-.256 0-.575.136-.845.405"
      clipRule="evenodd"
    />
    <path d="M10.75 11a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0zM14 10.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75" />
    <path d="M5.25 20.03 4.39 8h1.505l.853 11.947.002.053c0 .256.136.575.405.845.27.27.589.405.845.405h8c.256 0 .575-.136.845-.405.27-.27.405-.589.405-.845q0-.027.002-.053L18.105 8h1.504l-.86 12.03c-.009.732-.37 1.401-.844 1.875-.48.48-1.161.845-1.905.845H8c-.744 0-1.425-.364-1.905-.845-.474-.474-.835-1.143-.845-1.876" />
  </>
);

const Remove = Icon('remove', svgContents);

export default Remove;
